/* tslint:disable */
/* eslint-disable */
/**
 * leverup Service Application
 * Documentation for your application APIs v1.0
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  LeaderboardDataResponse,
  PagedLeaderboardDataResponse,
} from '../models/index';

export interface GetLeaderboard1Request {
    blockChain: GetLeaderboard1BlockChainEnum;
    timeframe?: GetLeaderboard1TimeframeEnum;
    sortField?: GetLeaderboard1SortFieldEnum;
    sortDirection?: GetLeaderboard1SortDirectionEnum;
    page?: number;
    size?: number;
    search?: string;
}

export interface GetMyRankRequest {
    userAddress: string;
    blockChain: GetMyRankBlockChainEnum;
    timeframe?: GetMyRankTimeframeEnum;
    sortField?: GetMyRankSortFieldEnum;
    sortDirection?: GetMyRankSortDirectionEnum;
}

export interface GetTeamLeaderboardRequest {
    teamCode: string;
    blockChain: GetTeamLeaderboardBlockChainEnum;
    timeframe?: GetTeamLeaderboardTimeframeEnum;
    sortField?: GetTeamLeaderboardSortFieldEnum;
    sortDirection?: GetTeamLeaderboardSortDirectionEnum;
    page?: number;
    size?: number;
    search?: string;
}

export interface GetUserTradingStatsRequest {
    userAddress: string;
    startTime: number;
    endTime: number;
    blockChain: GetUserTradingStatsBlockChainEnum;
}

/**
 * 
 */
export class LeaderboardControllerApi extends runtime.BaseAPI {

    /**
     */
    async getLeaderboard1Raw(requestParameters: GetLeaderboard1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagedLeaderboardDataResponse>> {
        if (requestParameters['blockChain'] == null) {
            throw new runtime.RequiredError(
                'blockChain',
                'Required parameter "blockChain" was null or undefined when calling getLeaderboard1().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['blockChain'] != null) {
            queryParameters['block_chain'] = requestParameters['blockChain'];
        }

        if (requestParameters['timeframe'] != null) {
            queryParameters['timeframe'] = requestParameters['timeframe'];
        }

        if (requestParameters['sortField'] != null) {
            queryParameters['sort_field'] = requestParameters['sortField'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sort_direction'] = requestParameters['sortDirection'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/leaderboard`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getLeaderboard1(requestParameters: GetLeaderboard1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagedLeaderboardDataResponse> {
        const response = await this.getLeaderboard1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getMyRankRaw(requestParameters: GetMyRankRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LeaderboardDataResponse>> {
        if (requestParameters['userAddress'] == null) {
            throw new runtime.RequiredError(
                'userAddress',
                'Required parameter "userAddress" was null or undefined when calling getMyRank().'
            );
        }

        if (requestParameters['blockChain'] == null) {
            throw new runtime.RequiredError(
                'blockChain',
                'Required parameter "blockChain" was null or undefined when calling getMyRank().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userAddress'] != null) {
            queryParameters['user_address'] = requestParameters['userAddress'];
        }

        if (requestParameters['blockChain'] != null) {
            queryParameters['block_chain'] = requestParameters['blockChain'];
        }

        if (requestParameters['timeframe'] != null) {
            queryParameters['timeframe'] = requestParameters['timeframe'];
        }

        if (requestParameters['sortField'] != null) {
            queryParameters['sort_field'] = requestParameters['sortField'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sort_direction'] = requestParameters['sortDirection'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/leaderboard/my-rank`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getMyRank(requestParameters: GetMyRankRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LeaderboardDataResponse> {
        const response = await this.getMyRankRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getTeamLeaderboardRaw(requestParameters: GetTeamLeaderboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagedLeaderboardDataResponse>> {
        if (requestParameters['teamCode'] == null) {
            throw new runtime.RequiredError(
                'teamCode',
                'Required parameter "teamCode" was null or undefined when calling getTeamLeaderboard().'
            );
        }

        if (requestParameters['blockChain'] == null) {
            throw new runtime.RequiredError(
                'blockChain',
                'Required parameter "blockChain" was null or undefined when calling getTeamLeaderboard().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['blockChain'] != null) {
            queryParameters['block_chain'] = requestParameters['blockChain'];
        }

        if (requestParameters['timeframe'] != null) {
            queryParameters['timeframe'] = requestParameters['timeframe'];
        }

        if (requestParameters['sortField'] != null) {
            queryParameters['sort_field'] = requestParameters['sortField'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sort_direction'] = requestParameters['sortDirection'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/leaderboard/team/{team_code}`.replace(`{${"team_code"}}`, encodeURIComponent(String(requestParameters['teamCode']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getTeamLeaderboard(requestParameters: GetTeamLeaderboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagedLeaderboardDataResponse> {
        const response = await this.getTeamLeaderboardRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getUserTradingStatsRaw(requestParameters: GetUserTradingStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LeaderboardDataResponse>> {
        if (requestParameters['userAddress'] == null) {
            throw new runtime.RequiredError(
                'userAddress',
                'Required parameter "userAddress" was null or undefined when calling getUserTradingStats().'
            );
        }

        if (requestParameters['startTime'] == null) {
            throw new runtime.RequiredError(
                'startTime',
                'Required parameter "startTime" was null or undefined when calling getUserTradingStats().'
            );
        }

        if (requestParameters['endTime'] == null) {
            throw new runtime.RequiredError(
                'endTime',
                'Required parameter "endTime" was null or undefined when calling getUserTradingStats().'
            );
        }

        if (requestParameters['blockChain'] == null) {
            throw new runtime.RequiredError(
                'blockChain',
                'Required parameter "blockChain" was null or undefined when calling getUserTradingStats().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['startTime'] != null) {
            queryParameters['start_time'] = requestParameters['startTime'];
        }

        if (requestParameters['endTime'] != null) {
            queryParameters['end_time'] = requestParameters['endTime'];
        }

        if (requestParameters['blockChain'] != null) {
            queryParameters['block_chain'] = requestParameters['blockChain'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/leaderboard/{user_address}/trading-stats`.replace(`{${"user_address"}}`, encodeURIComponent(String(requestParameters['userAddress']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getUserTradingStats(requestParameters: GetUserTradingStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LeaderboardDataResponse> {
        const response = await this.getUserTradingStatsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
  * @export
  * @enum {string}
  */
export enum GetLeaderboard1BlockChainEnum {
    Monad = 'MONAD'
}
/**
  * @export
  * @enum {string}
  */
export enum GetLeaderboard1TimeframeEnum {
    OneDay = 'ONE_DAY',
    SevenDay = 'SEVEN_DAY',
    ThirtyDay = 'THIRTY_DAY',
    All = 'ALL'
}
/**
  * @export
  * @enum {string}
  */
export enum GetLeaderboard1SortFieldEnum {
    Pnl = 'PNL',
    WinRate = 'WIN_RATE',
    BiggestWin = 'BIGGEST_WIN',
    TotalVolUsd = 'TOTAL_VOL_USD'
}
/**
  * @export
  * @enum {string}
  */
export enum GetLeaderboard1SortDirectionEnum {
    Asc = 'ASC',
    Desc = 'DESC'
}
/**
  * @export
  * @enum {string}
  */
export enum GetMyRankBlockChainEnum {
    Monad = 'MONAD'
}
/**
  * @export
  * @enum {string}
  */
export enum GetMyRankTimeframeEnum {
    OneDay = 'ONE_DAY',
    SevenDay = 'SEVEN_DAY',
    ThirtyDay = 'THIRTY_DAY',
    All = 'ALL'
}
/**
  * @export
  * @enum {string}
  */
export enum GetMyRankSortFieldEnum {
    Pnl = 'PNL',
    WinRate = 'WIN_RATE',
    BiggestWin = 'BIGGEST_WIN',
    TotalVolUsd = 'TOTAL_VOL_USD'
}
/**
  * @export
  * @enum {string}
  */
export enum GetMyRankSortDirectionEnum {
    Asc = 'ASC',
    Desc = 'DESC'
}
/**
  * @export
  * @enum {string}
  */
export enum GetTeamLeaderboardBlockChainEnum {
    Monad = 'MONAD'
}
/**
  * @export
  * @enum {string}
  */
export enum GetTeamLeaderboardTimeframeEnum {
    OneDay = 'ONE_DAY',
    SevenDay = 'SEVEN_DAY',
    ThirtyDay = 'THIRTY_DAY',
    All = 'ALL'
}
/**
  * @export
  * @enum {string}
  */
export enum GetTeamLeaderboardSortFieldEnum {
    Pnl = 'PNL',
    WinRate = 'WIN_RATE',
    BiggestWin = 'BIGGEST_WIN',
    TotalVolUsd = 'TOTAL_VOL_USD'
}
/**
  * @export
  * @enum {string}
  */
export enum GetTeamLeaderboardSortDirectionEnum {
    Asc = 'ASC',
    Desc = 'DESC'
}
/**
  * @export
  * @enum {string}
  */
export enum GetUserTradingStatsBlockChainEnum {
    Monad = 'MONAD'
}
